import create from 'zustand';
import { ABOUT_EXAM_SEC, BATCHES_SEC, EDUCATORS_SEC } from './constants';

const tabMapping = {
  educators: EDUCATORS_SEC,
  batches: BATCHES_SEC,
  'about-exam': ABOUT_EXAM_SEC
};

const useActiveSectionStore = create((set) => ({
  activeSec: '',
  setSec: (hashURI) => {
    const selectedTabId = tabMapping[hashURI.slice(1, hashURI.length)];
    set({
      activeSec: selectedTabId
    });
  }
}));

export default useActiveSectionStore;
